// extracted by mini-css-extract-plugin
export var divider = "_xm-0";